import { useState, useEffect } from "react";
import AdminGuard from "./AdminGuard";
import AdminLeftMenu from "components/admin/AdminLeftMenu";
import { FiChevronLeft, FiChevronRight, FiMenu, FiX } from "react-icons/fi";
import "./adminLayout.css";
import { debug } from "../utils";

export default function AdminLayout({ children, menu, config }) {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    document.body.classList.add("admin-layout");
    return () => document.body.classList.remove("admin-layout");
  }, []);

  return (


    <AdminGuard>

      <div className={`admin-layout-container ${config?.sidebar == false ? 'no-sidebar' : ''}`}>

        {/* Sidebar */}
        {config?.sidebar !== false &&
          <aside className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
            <div className="admin-sidebar-content">
              <AdminLeftMenu />
            </div>

            {/* Bouton burger / close */}
            <span
              className="admin-sidebar-toggle btn btn-primary px-0 py-0"
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed
                ? <FiMenu size={26} />       // burger quand la sidebar est fermée
                : <FiX size={26} />          // croix quand la sidebar est ouverte
              }
            </span>
          </aside>
        }

        {/* Contenu principal */}
        <main className="admin-main">

          {children}
        </main>

      </div>
    </AdminGuard>

  );
}
